<section class="blog-panel-container">
  <div #shareContainer>
    <h1 class="reader-title">{{ blog.title }}</h1>
    <h2 class="reader-subtitle font-regular">{{ blog.tagline }}</h2>
    <ng-container *ngIf="source === 'blogs'">
      <ng-container *ngIf="blog?.badges?.length">
        <a
          [href]="competitionUrl + blog.badges[0].compSlug + '/entries'"
          class="no-decor badge width-100 text-center font-xs">
          {{ blog.badges[0].title }}
        </a>
      </ng-container>

      <ng-container *ngIf="blog.content || blog.body">
        <div class="meta-container">
          <uni-user-avatar [user]="blog.author" avatarClass="blog-author-avatar-image">
          </uni-user-avatar>
          <p class="reader-meta" style="flex-grow: 1">
            <a [href]="getProfileUrl(blog)" class="cursor-pointer font-bold no-decor"
              >{{ blog.author.first_name }} {{ blog.author.last_name }}
            </a>
            published <span class="font-bold">{{ blog.type.name }}</span> on
            <span class="font-bold">{{ blog.created_at | date }}</span> under
            <span
              *ngFor="let discipline of blog.disciplines; last as last"
              class="cursor-pointer font-bold">
              <ng-container *ngIf="discipline.slug; else defaultView">
                <a [href]="goToTopic(discipline.slug)" class="no-decor-hover">
                  {{ discipline.name }}
                </a>
                <span *ngIf="!last">, </span>
              </ng-container>
              <ng-template #defaultView>
                <a [href]="getDisciplineSearchUrl(discipline)" class="no-decor">
                  {{ discipline.name }}
                </a>
                <span *ngIf="!last">, </span>
              </ng-template>
            </span>
          </p>
          <uni-share-button-group
            [item]="blog"
            [content]="sharedContent"
            [source]="source"
            [slug]="blog.slug"
            [report]="blog?.report"
            [user]="user"
            [sourceCopy]="blogCopyLink"
            [metaSection]="true"
            [mobileView]="mobileView"
            [self]="self">
          </uni-share-button-group>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class="blog-content" *ngIf="blog.content && !blog.body">
    <div [innerHtml]="content | safeContent"></div>
  </div>
  <div class="blog-content" *ngIf="blog.body">
    <div #editor></div>
  </div>

  <div *ngIf="blog.references && blog?.references.length > 0">
    <hr style="border: 0; border-top: 10px dotted #545454; width: 45px; margin: 64px auto 48px" />
    <p class="reference">References</p>
    <ul style="list-style: none; padding-left: 0">
      <li *ngFor="let reference of blog.references; index as i" class="margin-y-2">
        <p class="reference-text" *ngIf="reference.reference_type == 'PUBLICATION'">
          <span style="padding-right: 6px">{{ i + 1 }})</span>
          <span style="padding-right: 6px; font-weight: 500"
            >{{ reference.title | titlecase }} -
          </span>
          <span style="padding-right: 6px"
            ><i>{{ reference.volume }},</i></span
          >
          <span *ngIf="reference.isbn" style="padding-right: 6px">{{ reference.isbn }},</span>
          <span style="padding-right: 6px">{{ reference.author | titlecase }}</span>
          <span style="padding-right: 6px">[{{ reference.publisher | titlecase }}]</span>
        </p>

        <p
          class="reference-text cursor-pointer"
          *ngIf="reference.reference_type == 'WEBPAGE'"
          (click)="openUrl(reference.url)">
          <span style="padding-right: 6px">{{ i + 1 }})</span>
          <span style="padding-right: 6px"
            >{{ reference.title | titlecase }} &nbsp;
            <i class="icon-open-in-new-tab cursor-pointer"></i>
          </span>
        </p>
      </li>
    </ul>
  </div>

  <h6 class="tags-section">
    <mat-chip-list>
      <mat-chip *ngFor="let tag of blog.tags" class="tag-chip">
        <ng-container *ngIf="tag.image; else defaultTagIcon">
          <uni-image
            [src]="tag.image"
            [alt]="tag.name"
            [height]="24"
            [width]="24"
            classes="fit-cover align-middle circle margin-right-2 sparro-bg-white">
          </uni-image>
        </ng-container>
        <ng-template #defaultTagIcon>
          <i class="mat-chip-image icon-tag"> </i>
        </ng-template>
        <a [href]="goToTopic(tag.slug)" class="no-decor-hover" *ngIf="tag.slug"> {{ tag.name }} </a>
        <span *ngIf="!tag.slug"> {{ tag.name }} </span>
      </mat-chip>
    </mat-chip-list>
  </h6>
</section>
